export default {
      id: "bank-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#bank",
      toString: function () {
        return this.url;
      }
    }